import { render, staticRenderFns } from "./SsoApps.vue?vue&type=template&id=3a0583e3&scoped=true"
import script from "./SsoApps.vue?vue&type=script&lang=js"
export * from "./SsoApps.vue?vue&type=script&lang=js"
import style0 from "./SsoApps.vue?vue&type=style&index=0&id=3a0583e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0583e3",
  null
  
)

export default component.exports